import bootstrap from 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'normalize.css'
import 'jquery-datetimepicker/jquery.datetimepicker.css'
import '../css/icons.css'
import "../css/variables.css"
import "../css/fonts.css"
import "../css/typography.css"
/*import "../css/grid.css"*/
/*import "../css/template.css"*/
import "../css/header.css"
import "../css/database.css"
import "../css/form.css"
import "../css/filter.css"
import "../css/qr.css"
import "../css/userdoc.css"
import "../css/doctor-schedule.css"
import "../css/print.css"
import * as globalFuncs from "./globalFunctions.js";

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

import {actual_api} from "./actual_api"


window.Stimulus = Application.start()
const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))
global.api_url = 'https://api.actualoptic.kz:8443';
//global.api_url = 'http://localhost:8443';
global.wsURL =  "wss://api.actualoptic.kz:8443/websocket";
//global.wsURL =  "wss://localhost:8443/websocket";

global.globalFuncs = globalFuncs;
global.api = new  actual_api(global.api_url)


